// ── Styles ────────────────────────────────────────────────────────────────
import './styles/base.css';
import './styles/login.css';
import './styles/topbar.css';
import './styles/filters.css';
import './styles/bubbles.css';
import './styles/vehicle-detail.css';
import './styles/modal.css';
import './styles/fault-modal.css';
import './styles/help.css';
import './styles/idling.css';
import './styles/safety.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/heatmap.css';
import './styles/assets.css';
import './styles/login-audit.css';
import './styles/watchdog.css';
import './styles/reset-device.css';
import './styles/zone-activity.css';
import { registerAddin } from './addin';
import { initStandalone } from './standalone';
import { initThemeToggle } from './dashboard';

// ── Theme — initialize immediately so the button works before login ────────
initThemeToggle();

// ── Runtime mode detection ────────────────────────────────────────────────
// Geotab injects window.geotab before the page loads in add-in mode.
// Static imports ensure registerAddin() is called synchronously.

if (window.geotab) {
  registerAddin();
} else {
  initStandalone();
}
